/**
 * The game's Ember models and designs come from its content (`content/game/sprites/ember.json`,
 * compiled into the catalog), and follow it when a release is activated live.
 */
import { bindContent } from "../content/catalog"
import { registerEmberModels } from "./model"

bindContent(catalog => (catalog.source as any).ember, registerEmberModels)
